import StructuredPdfDocument from './StructuredPdfDocument';

export default StructuredPdfDocument;
